import { makeStyles } from '@material-ui/core/styles';
import {
    Paper,
    Popper,
    Tooltip,
    Button,
    TextField,
    Select,
    MenuItem,
    RadioGroup,
    FormControlLabel,
    Radio
} from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import {
    normalizeString,
    onSelectSugguestOption,
} from '@/component/ticketKnowledge/handler/ListTicketKnowledgeHandler';
import {
    onKeyPressSearchKeyWord,
    onSubmitSearchTicketList,
    openHelpdeskTicketListDrilldown,
    handleOnChangeSearchSynonym,
    handleChangeSearchMethod

} from '../handler/HelpDeskTicketListHandler';
import Constant from '@/common/constant/Constant';
import {
    handleChangeSearchAttribute,
    isDisplayOptionSearchSynonym,
} from '@/component/ticketKnowledge/handler/DrilldownAndDetailSearchHandler';
import { I18n } from 'aws-amplify';

const useStyles = makeStyles(theme => ({
    root: {
        display: 'flex',
        alignItems: 'center',
        flexGrow: 1,
        border: 'none',
        boxShadow: 'unset',
        borderRadius: '0px',
        '& .MuiTextField-root': {
            margin: '0',
            width: '100%'
        }
    },
    input: {
        marginLeft: theme.spacing(1),
        flex: 1,
        width: '100%'
    },
    iconButton: {
        padding: 10
    },
    divider: {
        height: '100%',
        margin: 4
    },
    arrowIcon: {
        fill: 'white'
    }
}));

export default function HelpdeskListSearchInput(props) {
    const classes = useStyles();
    const {
        API,
        inputKeyWordRef,
        keywordSearch,
        setKeywordSearch,
        sugguestionList,
        viewStructure,
        setViewStructure,
        setTriggerSearch,
        userDetail,
        projectInuseDetail,
        corporationDetail,
        addNewPanel,
        panelId
    } = props;

    return (
        <>
            <div className="searchFrame">
                <div className="searchFrame-wrap">
                    <div className="searchFrame-actions">
                        <Select
                            className="search-options-select"
                            variant="outlined"
                            defaultValue={Constant.SETTING_SEARCH_KEYWORD.MUTIPLE}
                            value={
                                viewStructure.options.attribute
                                    ? viewStructure.options.attribute
                                    : Constant.SETTING_SEARCH_KEYWORD.MUTIPLE
                            }
                            onChange={e => handleChangeSearchAttribute(e, props)}
                            MenuProps={{
                                anchorOrigin: {
                                    vertical: 'bottom',
                                    horizontal: 'left'
                                },
                                transformOrigin: {
                                    vertical: 'top',
                                    horizontal: 'left'
                                },
                                getContentAnchorEl: null,
                                className: 'selectDrop'
                            }}
                        >
                            <MenuItem value={Constant.SETTING_SEARCH_KEYWORD.MUTIPLE}>
                                {I18n.get('DRILLB012')}
                            </MenuItem>
                            <MenuItem value={Constant.SETTING_SEARCH_KEYWORD.COMMENT}>
                                {I18n.get('DRILLB013')}
                            </MenuItem>
                        </Select>
                        <Paper className={classes.root}>
                            <Autocomplete
                                PopperComponent={({ style, ...props }) => (
                                    <Popper
                                        {...props}
                                        style={{ ...style }} // width is passed in 'style' prop
                                        className="selectDrop"
                                    />
                                )}
                                className="search-keyword"
                                freeSolo
                                disablePortal
                                // loading={isLoadingDrillDown}
                                // loadingText={<LoadingPanel isLoading={isLoadingDrillDown} />}
                                sx={{
                                    maxHeight: 10
                                }}
                                options={keywordSearch ? sugguestionList : []}
                                getOptionLabel={option => {
                                    return option.label || '';
                                }}
                                filterOptions={(options, state) => {
                                    const keyword = normalizeString(state.inputValue);
                                    return options.filter((option) =>
                                        normalizeString(option.labelForSearch).includes(keyword)
                                    );
                                }}

                                // filterOptions={filterSugguestionOption}
                                renderOption={option => (
                                    <Tooltip title={option.label}>
                                        <span
                                            style={{
                                                overflow: 'hidden',
                                                whiteSpace: 'nowrap',
                                                textOverflow: 'ellipsis'
                                            }}
                                        >
                                            {option.label}
                                        </span>
                                    </Tooltip>
                                )}
                                onChange={(e, value) => onSelectSugguestOption(e, value, props)}
                                inputValue={keywordSearch}
                                renderInput={params => (
                                    <>
                                        <TextField
                                            {...params}
                                            // className={classes.input}
                                            defaultValue={viewStructure.keyword}
                                            placeholder="キーワードを入力してください"
                                            value={keywordSearch}
                                            onKeyPress={e => onKeyPressSearchKeyWord(e, props)}
                                            onChange={e => {
                                                setKeywordSearch(e.target.value);
                                            }}
                                            onKeyDown={e => {
                                                if (e.key === 'Enter') {
                                                    e.stopPropagation();
                                                }
                                            }}
                                            inputRef={inputKeyWordRef}
                                            variant="outlined"
                                        />
                                    </>
                                )}
                            />
                            <Button
                                className="btn-icon-search"
                                variant="contained"
                                color="primary"
                                onClick={e => onSubmitSearchTicketList(props)}
                            >
                                <img src="/assets/image/icon-searchFrame.svg" alt="" />
                            </Button>
                        </Paper>
                    </div>
                    <Button
                        className="btn-tag-search btn-light btn-hg32"
                        variant="outlined"
                        onClick={e => openHelpdeskTicketListDrilldown(props)}
                    >
                        <span className="itemSearch">
                            <img src="/assets/image/icon-btnSearch.svg" alt="" />
                        </span>
                        {I18n.get('CM-BUTTON-OPEN-DRILLDOWN')}
                    </Button>
                </div>
            </div>
            
            <div className='search-option-list-helpdesk'>
                <div className="search-options-radio">
                    {/* Search method and target */}
                    <div className="search-option-method-attribute content-padding">
                        <RadioGroup
                            id="radio-buttons-group-search-method"
                            key={`row-radio-buttons-group-search-method`}
                            row
                            aria-labelledby="radio-buttons-group-label-method"
                            name="row-radio-buttons-group-search-method"
                            value={
                                viewStructure.options.method
                                    ? viewStructure.options.method
                                    : Constant.SETTING_SEARCH_KEYWORD.AND
                            }
                            onChange={e => handleChangeSearchMethod(e, props)}
                        >
                            <div className="searchOption-radio">
                                <FormControlLabel
                                    className="custom-radio"
                                    value={Constant.SETTING_SEARCH_KEYWORD.AND}
                                    control={<Radio size="small" />}
                                    label={I18n.get('DRILLB010')}
                                />
                                <FormControlLabel
                                    className="custom-radio"
                                    value={Constant.SETTING_SEARCH_KEYWORD.OR}
                                    control={<Radio size="small" />}
                                    label={I18n.get('DRILLB011')}
                                />
                            </div>
                        </RadioGroup>
                    </div>
                </div>

                {/* Search helpdesk synonym */}
                {isDisplayOptionSearchSynonym(corporationDetail, projectInuseDetail) && 
                    <div className="search-synonym-option">
                        <Tooltip title={I18n.get('MSG-CM-USE-SYNONYM-KNOW-TO-SEARCH')} arrow= {true} placement = "top">
                            <div>
                                <input
                                    type="checkbox"
                                    id={`checkbox-include-search-synonym-helpdesk-list`}
                                    defaultChecked={viewStructure?.options?.isSearchSynonym ? true : false}
                                    checked={viewStructure?.options?.isSearchSynonym ? true : false}
                                    className="search-synonym-checkbox"
                                    onClick={e => {
                                        handleOnChangeSearchSynonym(e.target.checked, 'isSearchSynonym', {
                                            viewStructure,
                                            setViewStructure
                                        });
                                    }}
                                />
                                <label
                                    className="label-search-pdf"
                                    htmlFor={`checkbox-include-search-synonym-helpdesk-list`}
                                >
                                    {I18n.get('類義語展開する')}
                                </label>
                            </div>
                        </Tooltip>
                    </div>
                }
            </div>
        </>
    );
}
